import { useQuery, gql } from '@apollo/client';
import { useSelector } from 'react-redux';

export function useOverview() {
  const {
    waterQuality: {
      filterOrp: {
        register: { year, week, day },
      },
    },
  } = useSelector(({ state }) => state);
  let variables = { week, year, day };
  const { data = {}, loading } = useQuery(GET_OVERVIEW, {
    variables,
    skip: skip(variables),
  });
  return { loading, data: data.DataOrpLog || [] };
}

function skip(variables) {
  let skip = true;
  let { year, week, day } = variables;
  skip = ![year, week, day].every((v) => v);
  return skip;
}

const GET_OVERVIEW = gql`
  query ResponseOrpLog($year: Int!, $week: Int!, $day: Int!) {
    DataOrpLog: ResponseOrpLog(year: $year, week: $week, day: $day) {
      _id
      year
      week
      day
      data_point
      data_value
      hours_ori
      hours_apo
    }
  }
`;
